// utils/flags.js
export const guessFlag = (country) => {
    if (!country) return '🏳️'; // fallback white flag

    // 1. Use existing flag_code if available
    if (country.flag_code) return country.flag_code;

    // 2. Try to guess from ISO code if available
    if (country.iso) {
        return country.iso
            .toUpperCase()
            .replace(/./g, char =>
                String.fromCodePoint(127397 + char.charCodeAt())
            );
    }

    // 3. Try to guess from country name
    const nameMap = {
        India: '🇮🇳',
        Japan: '🇯🇵',
        'United Arab Emirates': '🇦🇪',
        USA: '🇺🇸',
        UK: '🇬🇧',
        Germany: '🇩🇪',
        France: '🇫🇷',
        China: '🇨🇳',
    };

    if (nameMap[country.name]) return nameMap[country.name];

    // 4. Fallback
    return '🏳️';
};
